// Allowlist of admin / founder emails for PartyBuddy.
//
// SECURITY TODO: This is CLIENT-SIDE admin logic for development / MVP only.
// Anyone can edit the bundled JavaScript, so this allowlist must NOT be the only
// line of defense. Before production, admin permissions MUST be enforced by
// Firestore Security Rules on the server (e.g. via Firebase custom auth claims,
// or a server-validated `admins` collection that clients cannot write to).
// The client checks below are only for shaping the UI and the MVP write paths.

export const ADMIN_EMAILS = [
  "sburdelj@gmail.com",
];

const normalizeEmail = (email) =>
  typeof email === "string" ? email.trim().toLowerCase() : "";

export const isAdminEmail = (email) =>
  ADMIN_EMAILS.map((e) => e.toLowerCase()).includes(normalizeEmail(email));

// Accepts a Firebase auth user OR a Firestore profile object.
// Treats the account as admin if it carries an admin flag/role, OR if its email
// is on the allowlist — so existing accounts created before this feature (and
// therefore missing `admin: true`) are still recognized as admin on login.
export const isAdminUser = (userOrProfile) => {
  if (!userOrProfile) return false;
  if (userOrProfile.admin === true) return true;
  if (userOrProfile.role === "admin") return true;
  return isAdminEmail(userOrProfile.email);
};
